var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[(_vm.school.logoUrl)?_c('v-avatar',{staticClass:"profile",attrs:{"tile":"","size":_vm.size}},[_c('img',{attrs:{"contain":"","src":_vm.school.logoUrl}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }